import { render, staticRenderFns } from "./CardAdditionalInformationIcon.vue?vue&type=template&id=f068101c&scoped=true"
import script from "./CardAdditionalInformationIcon.vue?vue&type=script&lang=js"
export * from "./CardAdditionalInformationIcon.vue?vue&type=script&lang=js"
import style0 from "./CardAdditionalInformationIcon.vue?vue&type=style&index=0&id=f068101c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f068101c",
  null
  
)

export default component.exports